// Sessions Drills data - maps consolidated drills to their skill categories
// This file handles the new consolidated soccer and martial arts drills (30-60 minute sessions)

import allDrills from './drills/index.js'; // Import all drills including consolidated drills
import { getDrillTimingById } from './skills-drills-timing-source-of-truth.js';
import {
  // Running Technique Skills
  running_form_skill,
  running_speed_agility_skill,
  running_beginner_endurance_skill,
  running_intermediate_endurance_skill,
  running_complete_beginner_skill,
  running_complete_intermediate_skill,
  // Taekwondo Skills
  taekwondo_basics_skill,
  taekwondo_kicks_skill,
  taekwondo_techniques_skill,
  taekwondo_stances_skill,
  taekwondo_footwork_skill,
  taekwondo_combinations_skill,
  taekwondo_defense_skill,
  taekwondo_sparring_skill,
  taekwondo_forms_skill,
  taekwondo_complete_beginner_skill,
  taekwondo_complete_intermediate_skill,
  taekwondo_complete_advanced_skill,
  taekwondo_championship_skill,
  // Yoga Skills
  yoga_basics_beginner_skill,
  yoga_basics_intermediate_skill,
  yoga_basics_advanced_skill,
  yoga_complete_beginner_skill,
  yoga_complete_intermediate_skill,
  yoga_complete_advanced_skill,
  // Volleyball Skills
  volleyball_beginner_passing_skill,
  volleyball_intermediate_passing_skill,
  volleyball_advanced_passing_skill,
  volleyball_beginner_setting_skill,
  volleyball_intermediate_setting_skill,
  volleyball_advanced_setting_skill,
  volleyball_beginner_serving_skill,
  volleyball_intermediate_serving_skill,
  volleyball_advanced_serving_skill,
  volleyball_complete_individual_skill,
  // Karate Skills
  karate_beginner_stances_skill,
  karate_intermediate_stances_skill,
  karate_advanced_stances_skill,
  karate_beginner_strikes_skill,
  karate_intermediate_strikes_skill,
  karate_advanced_strikes_skill,
  karate_beginner_blocks_skill,
  karate_intermediate_blocks_skill,
  karate_advanced_blocks_skill,
  karate_complete_individual_skill,
  karate_beginner_combat_skill,
  karate_intermediate_combat_skill,
  karate_advanced_combat_skill,
  // Dance Skills
  dance_beginner_movement_skill,
  dance_intermediate_movement_skill,
  dance_advanced_movement_skill,
  dance_beginner_rhythm_skill,
  dance_intermediate_rhythm_skill,
  dance_robot_rhythm_skill,
  dance_beginner_choreography_skill,
  dance_intermediate_choreography_skill,
  dance_advanced_choreography_skill,
  dance_complete_individual_skill,
  dance_beginner_combined_skill,
  dance_intermediate_combined_skill,
  dance_advanced_combined_skill,
  // Ballet Skills
  ballet_beginner_basics_skill,
  ballet_intermediate_basics_skill,
  ballet_advanced_basics_skill,
  ballet_beginner_movement_skill,
  ballet_intermediate_movement_skill,
  ballet_advanced_movement_skill,
  ballet_beginner_grace_skill,
  ballet_intermediate_grace_skill,
  ballet_advanced_grace_skill,
  ballet_complete_individual_skill,
  ballet_beginner_combined_skill,
  ballet_intermediate_combined_skill,
  ballet_advanced_combined_skill,
  // Baseball Skills
  baseball_beginner_hitting_skill,
  baseball_intermediate_hitting_skill,
  baseball_advanced_hitting_skill,
  baseball_beginner_fielding_skill,
  baseball_intermediate_fielding_skill,
  baseball_beginner_throwing_skill,
  baseball_intermediate_throwing_skill,
  baseball_advanced_throwing_skill,
  baseball_complete_individual_skill,
  baseball_beginner_combined_skill,
  baseball_intermediate_combined_skill,
  baseball_advanced_combined_skill,
  // Partner Baseball Skills
  baseball_partner_toss_catch_skill,
  baseball_partner_grounder_scoop_skill,
  baseball_partner_throw_accuracy_skill,
  baseball_partner_quick_hands_skill,
  baseball_partner_pop_fly_skill,
  baseball_partner_relay_skill,
  // Basketball Skills
  basketball_beginner_dribbling_skill,
  basketball_intermediate_dribbling_skill,
  basketball_advanced_dribbling_skill,
  basketball_beginner_shooting_skill,
  basketball_intermediate_shooting_skill,
  basketball_beginner_defense_skill,
  basketball_intermediate_defense_skill,
  basketball_advanced_defense_skill,
  basketball_complete_individual_skill,
  // Basketball Combined Skills
  basketball_beginner_complete_skill,
  basketball_intermediate_complete_skill,
  basketball_advanced_complete_skill,
} from './new-skills.js';
import {
  soccer_dribbling_skill,
  soccer_passing_skill,
  soccer_technique_skill,
  soccer_partner_passing_skill,
  soccer_partner_control_skill,
  soccer_partner_skills_skill,
  basketball_dribbling_skill,
  basketball_shooting_skill,
  basketball_defense_skill,
  // basketball_complete_skill,
  martial_arts_beginner_stances_skill,
  martial_arts_intermediate_stances_skill,
  martial_arts_advanced_stances_skill,
  martial_arts_beginner_strikes_skill,
  martial_arts_intermediate_strikes_skill,
  martial_arts_advanced_strikes_skill,
  martial_arts_beginner_blocks_skill,
  martial_arts_intermediate_blocks_skill,
  martial_arts_advanced_blocks_skill,
  // karate_stance_skill,
  // karate_striking_skill,
  // karate_blocking_skill,
  // karate_complete_skill,
  // dance_movement_skill,
  dance_rhythm_skill,
  // dance_choreography_skill,
  // dance_complete_skill,
  // volleyball_passing_skill,
  // volleyball_setting_skill,
  // volleyball_serving_skill,
  // volleyball_complete_skill,
  // movement_coordination_movement_skill,
  // movement_coordination_balance_skill,
  // movement_coordination_coordination_skill,
  // movement_coordination_complete_skill,
  // ballet_basics_skill,
  // ballet_movement_skill,
  // ballet_grace_skill,
  // ballet_complete_skill,
  boxing_basics_skill,
  boxing_footwork_skill,
  boxing_defense_skill,
  boxing_complete_skill,
  // yoga_basics_skill,
  // yoga_flow_skill,
  // yoga_balance_skill,
  // yoga_complete_skill,
  // taekwondo_basics_skill,
  // taekwondo_kicks_skill,
  // taekwondo_techniques_skill,
  // taekwondo_complete_skill,
  // taekwondo_stances_skill,
  // taekwondo_footwork_skill,
  // taekwondo_combinations_skill,
  // taekwondo_defense_skill,
  // taekwondo_sparring_skill,
  // taekwondo_forms_skill,
  // taekwondo_championship_skill,
} from './latest_skills.js';

// Helper: 1 point per minute using source-of-truth audio minutes when available
const computePointsFromSourceOfTruth = (drill) => {
  try {
    const timing = getDrillTimingById(drill.id);
    if (timing && typeof timing.totalMinutes === 'number') {
      return timing.totalMinutes;
    }
  } catch (_) {}
  return Math.floor((drill.timeTotal || 0) / 60);
};

// Add basketball drills to the sessions
const basketballDrills = allDrills
  .filter((drill) => drill.sports && drill.sports.includes('basketball'))
  .map((drill) => {
    // Map basketball drill skills to skill objects based on skill and difficulty
    let skill;
    if (drill.skill === 'Dribbling') {
      if (drill.difficulty === 'beginner') {
        skill = basketball_beginner_dribbling_skill;
      } else if (drill.difficulty === 'intermediate') {
        skill = basketball_intermediate_dribbling_skill;
      } else if (drill.difficulty === 'advanced') {
        skill = basketball_advanced_dribbling_skill;
      } else {
        skill = basketball_beginner_dribbling_skill; // Default fallback
      }
    } else if (drill.skill === 'Shooting') {
      if (drill.difficulty === 'beginner') {
        skill = basketball_beginner_shooting_skill;
      } else if (drill.difficulty === 'intermediate') {
        skill = basketball_intermediate_shooting_skill;
      } else {
        skill = basketball_beginner_shooting_skill; // Default fallback
      }
    } else if (drill.skill === 'Defense') {
      if (drill.difficulty === 'beginner') {
        skill = basketball_beginner_defense_skill;
      } else if (drill.difficulty === 'intermediate') {
        skill = basketball_intermediate_defense_skill;
      } else if (drill.difficulty === 'advanced') {
        skill = basketball_advanced_defense_skill;
      } else {
        skill = basketball_beginner_defense_skill; // Default fallback
      }
    } else if (drill.skill === 'Complete') {
      skill = basketball_complete_individual_skill;
    } else {
      skill = basketball_beginner_dribbling_skill; // Default fallback
    }

    return {
      drillId: drill.id,
      sport: 'basketball',
      skill: drill.skill, // Use the skill name directly
      title: drill.name,
      description: drill.instructions,
      difficulty: drill.difficulty,
      ageRange: '6-10',
      duration: Math.floor(drill.timeTotal / 60), // Convert seconds to minutes
      points: computePointsFromSourceOfTruth(drill),
      exercises: [
        // Create a single exercise object from the drill data
        {
          id: drill.id,
          name: drill.name,
          title: drill.name,
          description: drill.instructions,
          instructions: drill.instructions,
          duration: drill.timeTotal,
          equipment: drill.equipment,
          timedInstructions: drill.timedInstructions,
        },
      ],
      intro: skill?.intro || `Welcome to ${drill.name}! Let's get started!`,
      completion:
        skill?.completion ||
        `Great job completing ${drill.name}! You're a basketball master!`,
      requiresPartner: false, // Basketball drills are individual
      minPlayers: 1,
    };
  });

// Add basketball combined skills to the sessions
const basketballSkills = [
  {
    drillId: basketball_beginner_complete_skill.skillId,
    sport: 'basketball',
    skill: 'Complete',
    title: basketball_beginner_complete_skill.title,
    description: basketball_beginner_complete_skill.description,
    difficulty: basketball_beginner_complete_skill.difficulty,
    ageRange: '6-10',
    duration: basketball_beginner_complete_skill.duration,
    points: basketball_beginner_complete_skill.points,
    exercises: basketball_beginner_complete_skill.drills.map((drillId) => {
      const drill = allDrills.find((d) => d.id === drillId);
      return {
        id: drillId,
        name: drill?.name || `Basketball Drill ${drillId}`,
        title: drill?.name || `Basketball Drill ${drillId}`,
        description: drill?.instructions || '',
        instructions: drill?.instructions || '',
        duration: drill?.timeTotal || 0,
        equipment: drill?.equipment || '',
        timedInstructions: drill?.timedInstructions || [],
      };
    }),
    intro:
      basketball_beginner_complete_skill.intro ||
      "Welcome to Beginner Complete Basketball! Let's get started!",
    completion:
      basketball_beginner_complete_skill.completion ||
      "Great job completing Beginner Complete Basketball! You're a basketball master!",
    requiresPartner: false,
    minPlayers: 1,
  },
  {
    drillId: basketball_intermediate_complete_skill.skillId,
    sport: 'basketball',
    skill: 'Complete',
    title: basketball_intermediate_complete_skill.title,
    description: basketball_intermediate_complete_skill.description,
    difficulty: basketball_intermediate_complete_skill.difficulty,
    ageRange: '6-10',
    duration: basketball_intermediate_complete_skill.duration,
    points: basketball_intermediate_complete_skill.points,
    exercises: basketball_intermediate_complete_skill.drills.map((drillId) => {
      const drill = allDrills.find((d) => d.id === drillId);
      return {
        id: drillId,
        name: drill?.name || `Basketball Drill ${drillId}`,
        title: drill?.name || `Basketball Drill ${drillId}`,
        description: drill?.instructions || '',
        instructions: drill?.instructions || '',
        duration: drill?.timeTotal || 0,
        equipment: drill?.equipment || '',
        timedInstructions: drill?.timedInstructions || [],
      };
    }),
    intro:
      basketball_intermediate_complete_skill.intro ||
      "Welcome to Intermediate Complete Basketball! Let's get started!",
    completion:
      basketball_intermediate_complete_skill.completion ||
      "Great job completing Intermediate Complete Basketball! You're a basketball master!",
    requiresPartner: false,
    minPlayers: 1,
  },
  {
    drillId: basketball_advanced_complete_skill.skillId,
    sport: 'basketball',
    skill: 'Complete',
    title: basketball_advanced_complete_skill.title,
    description: basketball_advanced_complete_skill.description,
    difficulty: basketball_advanced_complete_skill.difficulty,
    ageRange: '6-10',
    duration: basketball_advanced_complete_skill.duration,
    points: basketball_advanced_complete_skill.points,
    exercises: basketball_advanced_complete_skill.drills.map((drillId) => {
      const drill = allDrills.find((d) => d.id === drillId);
      return {
        id: drillId,
        name: drill?.name || `Basketball Drill ${drillId}`,
        title: drill?.name || `Basketball Drill ${drillId}`,
        description: drill?.instructions || '',
        instructions: drill?.instructions || '',
        duration: drill?.timeTotal || 0,
        equipment: drill?.equipment || '',
        timedInstructions: drill?.timedInstructions || [],
      };
    }),
    intro:
      basketball_advanced_complete_skill.intro ||
      "Welcome to Advanced Complete Basketball! Let's get started!",
    completion:
      basketball_advanced_complete_skill.completion ||
      "Great job completing Advanced Complete Basketball! You're a basketball master!",
    requiresPartner: false,
    minPlayers: 1,
  },
];

// Add baseball drills to the sessions
const baseballDrills = allDrills
  .filter((drill) => drill.sports && drill.sports.includes('baseball'))
  .map((drill) => {
    // Map baseball drill skills to skill objects based on skill and difficulty
    let skill;
    if (drill.skill === 'Hitting') {
      if (drill.difficulty === 'beginner') {
        skill = baseball_beginner_hitting_skill;
      } else if (drill.difficulty === 'intermediate') {
        skill = baseball_intermediate_hitting_skill;
      } else if (drill.difficulty === 'advanced') {
        skill = baseball_advanced_hitting_skill;
      } else {
        skill = baseball_beginner_hitting_skill; // Default fallback
      }
    } else if (drill.skill === 'Fielding') {
      if (drill.difficulty === 'beginner') {
        skill = baseball_beginner_fielding_skill;
      } else if (drill.difficulty === 'intermediate') {
        skill = baseball_intermediate_fielding_skill;
      } else if (drill.difficulty === 'advanced') {
        skill = baseball_beginner_fielding_skill; // Default fallback (no advanced fielding skill)
      } else {
        skill = baseball_beginner_fielding_skill; // Default fallback
      }
    } else if (drill.skill === 'Throwing') {
      if (drill.difficulty === 'beginner') {
        skill = baseball_beginner_throwing_skill;
      } else if (drill.difficulty === 'intermediate') {
        skill = baseball_intermediate_throwing_skill;
      } else if (drill.difficulty === 'advanced') {
        skill = baseball_advanced_throwing_skill;
      } else {
        skill = baseball_beginner_throwing_skill; // Default fallback
      }
    } else if (drill.skill === 'Complete') {
      skill = baseball_complete_individual_skill;
    } else if (drill.skill === 'Partner') {
      if (drill.difficulty === 'beginner') {
        if (drill.id === 2160) {
          skill = baseball_partner_toss_catch_skill;
        } else if (drill.id === 2161) {
          skill = baseball_partner_grounder_scoop_skill;
        } else {
          skill = baseball_partner_toss_catch_skill; // Default fallback
        }
      } else if (drill.difficulty === 'intermediate') {
        if (drill.id === 2162) {
          skill = baseball_partner_throw_accuracy_skill;
        } else if (drill.id === 2163) {
          skill = baseball_partner_quick_hands_skill;
        } else {
          skill = baseball_partner_throw_accuracy_skill; // Default fallback
        }
      } else if (drill.difficulty === 'advanced') {
        if (drill.id === 2164) {
          skill = baseball_partner_pop_fly_skill;
        } else if (drill.id === 2165) {
          skill = baseball_partner_relay_skill;
        } else {
          skill = baseball_partner_pop_fly_skill; // Default fallback
        }
      } else {
        skill = baseball_partner_toss_catch_skill; // Default fallback
      }
    } else {
      skill = baseball_beginner_hitting_skill; // Default fallback
    }

    return {
      drillId: drill.id,
      sport: 'baseball',
      skill: drill.skill,
      title: drill.name,
      description: drill.instructions,
      difficulty: drill.difficulty,
      ageRange: '6-10',
      duration: Math.floor(drill.timeTotal / 60),
      points: computePointsFromSourceOfTruth(drill),
      exercises: [
        {
          id: drill.id,
          name: drill.name,
          title: drill.name,
          description: drill.instructions,
          instructions: drill.instructions,
          duration: drill.timeTotal,
          equipment: drill.equipment,
          timedInstructions: drill.timedInstructions,
        },
      ],
      intro: skill?.intro || `Welcome to ${drill.name}! Let's get started!`,
      completion:
        skill?.completion ||
        `Great job completing ${drill.name}! You're a baseball master!`,
      requiresPartner: drill.categories && drill.categories.includes('partner'),
      minPlayers:
        drill.categories && drill.categories.includes('partner') ? 2 : 1,
    };
  });

// Add baseball skills (combined workouts)
const baseballSkills = [
  baseball_beginner_combined_skill,
  baseball_intermediate_combined_skill,
  baseball_advanced_combined_skill,
].map((skill) => ({
  drillId: skill.skillId,
  sport: skill.sport,
  skill: skill.skill || skill.title, // Use title as fallback for skill
  title: skill.title,
  description: skill.description,
  difficulty: skill.difficulty,
  ageRange: '6-10',
  duration: skill.duration,
  points: skill.points,
  exercises: [], // These are complete workouts, not individual drills
  intro: `Welcome to ${skill.title}! Let's get started!`,
  completion: `Great job completing ${skill.title}! You're a baseball master!`,
  requiresPartner: false,
  minPlayers: 1,
}));

// Add karate drills to the sessions
const karateDrills = allDrills
  .filter((drill) => drill.sports && drill.sports.includes('karate'))
  .map((drill) => {
    // Map karate drill skills to skill objects based on skill and difficulty
    let skill;
    if (drill.skill === 'Stances') {
      if (drill.difficulty === 'beginner') {
        skill = karate_beginner_stances_skill;
      } else if (drill.difficulty === 'intermediate') {
        skill = karate_intermediate_stances_skill;
      } else if (drill.difficulty === 'advanced') {
        skill = karate_advanced_stances_skill;
      } else {
        skill = karate_beginner_stances_skill; // Default fallback
      }
    } else if (drill.skill === 'Strikes') {
      if (drill.difficulty === 'beginner') {
        skill = karate_beginner_strikes_skill;
      } else if (drill.difficulty === 'intermediate') {
        skill = karate_intermediate_strikes_skill;
      } else if (drill.difficulty === 'advanced') {
        skill = karate_advanced_strikes_skill;
      } else {
        skill = karate_beginner_strikes_skill; // Default fallback
      }
    } else if (drill.skill === 'Blocks') {
      if (drill.difficulty === 'beginner') {
        skill = karate_beginner_blocks_skill;
      } else if (drill.difficulty === 'intermediate') {
        skill = karate_intermediate_blocks_skill;
      } else if (drill.difficulty === 'advanced') {
        skill = karate_advanced_blocks_skill;
      } else {
        skill = karate_beginner_blocks_skill; // Default fallback
      }
    } else if (drill.skill === 'Complete') {
      skill = karate_complete_individual_skill;
    } else {
      skill = karate_beginner_stances_skill; // Default fallback
    }

    return {
      drillId: drill.id,
      sport: 'karate',
      skill: drill.skill, // Use the skill name directly
      title: drill.name,
      description: drill.instructions,
      difficulty: drill.difficulty,
      ageRange: '6-10',
      duration: Math.floor(drill.timeTotal / 60), // Convert seconds to minutes
      points: computePointsFromSourceOfTruth(drill),
      exercises: [
        // Create a single exercise object from the drill data
        {
          id: drill.id,
          name: drill.name,
          title: drill.name,
          description: drill.instructions,
          instructions: drill.instructions,
          duration: drill.timeTotal,
          equipment: drill.equipment,
          timedInstructions: drill.timedInstructions,
        },
      ],
      intro: skill.intro || `Welcome to ${drill.name}! Let's get started!`,
      completion:
        skill.completion ||
        `Great job completing ${drill.name}! You're a karate master!`,
      requiresPartner: false, // Karate drills are individual
      minPlayers: 1,
    };
  });

// Add martial arts drills to the sessions
const martialArtsDrills = allDrills
  .filter((drill) => drill.sports && drill.sports.includes('martial-arts'))
  .map((drill) => {
    // Map martial arts drill skills to skill objects based on difficulty
    let skill;
    if (drill.skill === 'Stances') {
      if (drill.difficulty === 'beginner')
        skill = martial_arts_beginner_stances_skill;
      else if (drill.difficulty === 'intermediate')
        skill = martial_arts_intermediate_stances_skill;
      else if (drill.difficulty === 'advanced')
        skill = martial_arts_advanced_stances_skill;
    } else if (drill.skill === 'Strikes') {
      if (drill.difficulty === 'beginner')
        skill = martial_arts_beginner_strikes_skill;
      else if (drill.difficulty === 'intermediate')
        skill = martial_arts_intermediate_strikes_skill;
      else if (drill.difficulty === 'advanced')
        skill = martial_arts_advanced_strikes_skill;
    } else if (drill.skill === 'Blocks') {
      if (drill.difficulty === 'beginner')
        skill = martial_arts_beginner_blocks_skill;
      else if (drill.difficulty === 'intermediate')
        skill = martial_arts_intermediate_blocks_skill;
      else if (drill.difficulty === 'advanced')
        skill = martial_arts_advanced_blocks_skill;
    }

    // Default fallback
    if (!skill) skill = martial_arts_beginner_stances_skill;

    return {
      drillId: drill.id,
      sport: 'martial-arts',
      skill: drill.skill, // Use the skill name directly
      title: drill.name,
      description: drill.instructions,
      difficulty: drill.difficulty,
      ageRange: '6-10',
      duration: Math.floor(drill.timeTotal / 60), // Convert seconds to minutes
      points: computePointsFromSourceOfTruth(drill),
      exercises: [
        // Create a single exercise object from the drill data
        {
          id: drill.id,
          name: drill.name,
          title: drill.name,
          description: drill.instructions,
          instructions: drill.instructions,
          duration: drill.timeTotal,
          equipment: drill.equipment,
          timedInstructions: drill.timedInstructions,
        },
      ],
      intro:
        skill.martial_arts?.intro ||
        `Welcome to ${drill.name}! Let's get started!`,
      completion:
        skill.martial_arts?.completion ||
        `Great job completing ${drill.name}! You're a martial arts master!`,
      requiresPartner: false, // Martial arts drills are individual
      minPlayers: 1,
    };
  });

// Add dance drills to the sessions
const danceDrills = allDrills
  .filter((drill) => drill.sports && drill.sports.includes('dance'))
  .map((drill) => {
    // Map dance drill skills to skill objects based on skill and difficulty
    let skill;
    if (drill.skill === 'Movement') {
      if (drill.difficulty === 'beginner') {
        skill = dance_beginner_movement_skill;
      } else if (drill.difficulty === 'intermediate') {
        skill = dance_intermediate_movement_skill;
      } else if (drill.difficulty === 'advanced') {
        skill = dance_advanced_movement_skill;
      } else {
        skill = dance_beginner_movement_skill; // Default fallback
      }
    } else if (drill.skill === 'Rhythm') {
      if (drill.difficulty === 'beginner') {
        skill = dance_beginner_rhythm_skill;
      } else if (drill.difficulty === 'intermediate') {
        skill = dance_intermediate_rhythm_skill;
      } else if (drill.difficulty === 'advanced') {
        skill = dance_robot_rhythm_skill;
      } else {
        skill = dance_beginner_rhythm_skill; // Default fallback
      }
    } else if (drill.skill === 'Choreography') {
      if (drill.difficulty === 'beginner') {
        skill = dance_beginner_choreography_skill;
      } else if (drill.difficulty === 'intermediate') {
        skill = dance_intermediate_choreography_skill;
      } else if (drill.difficulty === 'advanced') {
        skill = dance_advanced_choreography_skill;
      } else {
        skill = dance_beginner_choreography_skill; // Default fallback
      }
    } else if (drill.skill === 'Complete') {
      skill = dance_complete_individual_skill;
    } else {
      skill = dance_beginner_movement_skill; // Default fallback
    }

    return {
      drillId: drill.id,
      sport: 'dance',
      skill: drill.skill, // Use the skill name directly
      title: drill.name,
      description: drill.instructions,
      difficulty: drill.difficulty,
      ageRange: '6-10',
      duration: Math.floor(drill.timeTotal / 60), // Convert seconds to minutes
      points: computePointsFromSourceOfTruth(drill),
      exercises: [
        // Create a single exercise object from the drill data
        {
          id: drill.id,
          name: drill.name,
          title: drill.name,
          description: drill.instructions,
          instructions: drill.instructions,
          duration: drill.timeTotal,
          equipment: drill.equipment,
          timedInstructions: drill.timedInstructions,
        },
      ],
      intro: skill.intro || `Welcome to ${drill.name}! Let's get started!`,
      completion:
        skill.completion ||
        `Great job completing ${drill.name}! You're a dance master!`,
      requiresPartner: false, // Dance drills are individual
      minPlayers: 1,
    };
  });

// Add volleyball drills to the sessions
const volleyballDrills = allDrills
  .filter((drill) => drill.sports && drill.sports.includes('volleyball'))
  .map((drill) => {
    // Map volleyball drill skills to skill objects based on skill and difficulty
    let skill;
    if (drill.skill === 'Passing') {
      if (drill.difficulty === 'beginner') {
        skill = volleyball_beginner_passing_skill;
      } else if (drill.difficulty === 'intermediate') {
        skill = volleyball_intermediate_passing_skill;
      } else if (drill.difficulty === 'advanced') {
        skill = volleyball_advanced_passing_skill;
      } else {
        skill = volleyball_beginner_passing_skill; // Default fallback
      }
    } else if (drill.skill === 'Setting') {
      if (drill.difficulty === 'beginner') {
        skill = volleyball_beginner_setting_skill;
      } else if (drill.difficulty === 'intermediate') {
        skill = volleyball_intermediate_setting_skill;
      } else if (drill.difficulty === 'advanced') {
        skill = volleyball_advanced_setting_skill;
      } else {
        skill = volleyball_beginner_setting_skill; // Default fallback
      }
    } else if (drill.skill === 'Serving') {
      if (drill.difficulty === 'beginner') {
        skill = volleyball_beginner_serving_skill;
      } else if (drill.difficulty === 'intermediate') {
        skill = volleyball_intermediate_serving_skill;
      } else if (drill.difficulty === 'advanced') {
        skill = volleyball_advanced_serving_skill;
      } else {
        skill = volleyball_beginner_serving_skill; // Default fallback
      }
    } else if (drill.skill === 'Complete') {
      skill = volleyball_complete_individual_skill;
    } else {
      skill = volleyball_beginner_passing_skill; // Default fallback
    }

    return {
      drillId: drill.id,
      sport: 'volleyball',
      skill: drill.skill, // Use the skill name directly
      title: drill.name,
      description: drill.instructions,
      difficulty: drill.difficulty,
      ageRange: '6-10',
      duration: Math.floor(drill.timeTotal / 60), // Convert seconds to minutes
      points: computePointsFromSourceOfTruth(drill),
      exercises: [
        // Create a single exercise object from the drill data
        {
          id: drill.id,
          name: drill.name,
          title: drill.name,
          description: drill.instructions,
          instructions: drill.instructions,
          duration: drill.timeTotal,
          equipment: drill.equipment,
          timedInstructions: drill.timedInstructions,
        },
      ],
      intro: skill.intro || `Welcome to ${drill.name}! Let's get started!`,
      completion:
        skill.completion ||
        `Great job completing ${drill.name}! You're a volleyball master!`,
      requiresPartner: drill.categories && drill.categories.includes('partner'),
      minPlayers:
        drill.categories && drill.categories.includes('partner') ? 2 : 1,
    };
  });

// Add movement & coordination drills to the sessions
const movementCoordinationDrills = allDrills
  .filter(
    (drill) =>
      drill.sports &&
      (drill.sports.includes('movement-coordination') ||
        drill.sports.includes('gymnastics'))
  )
  .map((drill) => {
    // Map movement & coordination drill skills to skill objects
    const skillNameToSkill = {
      // Movement: movement_coordination_movement_skill,
      // Balance: movement_coordination_balance_skill,
      // Coordination: movement_coordination_coordination_skill,
      // Complete: movement_coordination_complete_skill,
    };

    const skill = skillNameToSkill[drill.skill] || basketball_dribbling_skill; // Fallback to basketball skill

    return {
      drillId: drill.id,
      sport: 'gymnastics',
      skill: drill.skill, // Use the skill name directly
      title: drill.name,
      description: drill.instructions,
      difficulty: drill.difficulty,
      ageRange: '6-10',
      duration: Math.floor(drill.timeTotal / 60), // Convert seconds to minutes
      points: computePointsFromSourceOfTruth(drill),
      exercises: [
        // Create a single exercise object from the drill data
        {
          id: drill.id,
          name: drill.name,
          title: drill.name,
          description: drill.instructions,
          instructions: drill.instructions,
          duration: drill.timeTotal,
          equipment: drill.equipment,
          timedInstructions: drill.timedInstructions,
        },
      ],
      intro:
        skill['movement-coordination']?.intro ||
        `Welcome to ${drill.name}! Let's get started!`,
      completion:
        skill['movement-coordination']?.completion ||
        `Great job completing ${drill.name}! You're a movement and coordination master!`,
      requiresPartner: false, // Movement & coordination drills are individual
      minPlayers: 1,
    };
  });

// Add ballet drills to the sessions
const balletDrills = allDrills
  .filter((drill) => drill.sports && drill.sports.includes('ballet'))
  .map((drill) => {
    // Map ballet drill skills to skill objects based on skill and difficulty
    let skill;
    if (drill.skill === 'Basics') {
      if (drill.difficulty === 'beginner') {
        skill = ballet_beginner_basics_skill;
      } else if (drill.difficulty === 'intermediate') {
        skill = ballet_intermediate_basics_skill;
      } else if (drill.difficulty === 'advanced') {
        skill = ballet_advanced_basics_skill;
      } else {
        skill = ballet_beginner_basics_skill; // Default fallback
      }
    } else if (drill.skill === 'Movement') {
      if (drill.difficulty === 'beginner') {
        skill = ballet_beginner_movement_skill;
      } else if (drill.difficulty === 'intermediate') {
        skill = ballet_intermediate_movement_skill;
      } else if (drill.difficulty === 'advanced') {
        skill = ballet_advanced_movement_skill;
      } else {
        skill = ballet_beginner_movement_skill; // Default fallback
      }
    } else if (drill.skill === 'Grace') {
      if (drill.difficulty === 'beginner') {
        skill = ballet_beginner_grace_skill;
      } else if (drill.difficulty === 'intermediate') {
        skill = ballet_intermediate_grace_skill;
      } else if (drill.difficulty === 'advanced') {
        skill = ballet_advanced_grace_skill;
      } else {
        skill = ballet_beginner_grace_skill; // Default fallback
      }
    } else if (drill.skill === 'Complete') {
      skill = ballet_complete_individual_skill;
    } else {
      skill = ballet_beginner_basics_skill; // Default fallback
    }

    return {
      drillId: drill.id,
      sport: 'ballet',
      skill: drill.skill, // Use the skill name directly
      title: drill.name,
      description: drill.instructions,
      difficulty: drill.difficulty,
      ageRange: '6-10',
      duration: Math.floor(drill.timeTotal / 60), // Convert seconds to minutes
      points: computePointsFromSourceOfTruth(drill),
      exercises: [
        // Create a single exercise object from the drill data
        {
          id: drill.id,
          name: drill.name,
          title: drill.name,
          description: drill.instructions,
          instructions: drill.instructions,
          duration: drill.timeTotal,
          equipment: drill.equipment,
          timedInstructions: drill.timedInstructions,
        },
      ],
      intro: skill?.intro || `Welcome to ${drill.name}! Let's get started!`,
      completion:
        skill?.completion ||
        `Great job completing ${drill.name}! You're a ballet master!`,
      requiresPartner: false, // Ballet drills are individual
      minPlayers: 1,
    };
  });

// Add boxing drills to the sessions
const boxingDrills = allDrills
  .filter((drill) => drill.sports && drill.sports.includes('boxing'))
  .map((drill) => {
    // Map boxing drill skills to skill objects
    const skillNameToSkill = {
      Basics: boxing_basics_skill,
      Footwork: boxing_footwork_skill,
      Defense: boxing_defense_skill,
      Complete: boxing_complete_skill,
    };

    const skill = skillNameToSkill[drill.skill] || basketball_dribbling_skill; // Fallback to basketball skill

    return {
      drillId: drill.id,
      sport: 'boxing',
      skill: drill.skill, // Use the skill name directly
      title: drill.name,
      description: drill.instructions,
      difficulty: drill.difficulty,
      ageRange: '6-10',
      duration: Math.floor(drill.timeTotal / 60), // Convert seconds to minutes
      points: computePointsFromSourceOfTruth(drill),
      exercises: [
        // Create a single exercise object from the drill data
        {
          id: drill.id,
          name: drill.name,
          title: drill.name,
          description: drill.instructions,
          instructions: drill.instructions,
          duration: drill.timeTotal,
          equipment: drill.equipment,
          timedInstructions: drill.timedInstructions,
        },
      ],
      intro:
        skill.boxing?.intro || `Welcome to ${drill.name}! Let's get started!`,
      completion:
        skill.boxing?.completion ||
        `Great job completing ${drill.name}! You're a boxing master!`,
      requiresPartner: false, // Boxing drills are individual
      minPlayers: 1,
    };
  });

// Add taekwondo drills to the sessions
const taekwondoDrills = allDrills
  .filter((drill) => drill.sports && drill.sports.includes('taekwondo'))
  .map((drill) => {
    // Map taekwondo drill skills to skill objects based on skill and difficulty
    let skill;
    if (drill.skill === 'Basics') {
      skill = taekwondo_basics_skill;
    } else if (drill.skill === 'Kicks') {
      skill = taekwondo_kicks_skill;
    } else if (drill.skill === 'Techniques') {
      skill = taekwondo_techniques_skill;
    } else if (drill.skill === 'Stances') {
      skill = taekwondo_stances_skill;
    } else if (drill.skill === 'Footwork') {
      skill = taekwondo_footwork_skill;
    } else if (drill.skill === 'Combinations') {
      skill = taekwondo_combinations_skill;
    } else if (drill.skill === 'Defense') {
      skill = taekwondo_defense_skill;
    } else if (drill.skill === 'Sparring') {
      skill = taekwondo_sparring_skill;
    } else if (drill.skill === 'Forms') {
      skill = taekwondo_forms_skill;
    } else if (drill.skill === 'Complete') {
      if (drill.difficulty === 'beginner') {
        skill = taekwondo_complete_beginner_skill;
      } else if (drill.difficulty === 'intermediate') {
        skill = taekwondo_complete_intermediate_skill;
      } else if (drill.difficulty === 'advanced') {
        skill = taekwondo_complete_advanced_skill;
      } else {
        skill = taekwondo_complete_beginner_skill; // Default fallback
      }
    } else if (drill.skill === 'Championship') {
      skill = taekwondo_championship_skill;
    } else {
      skill = taekwondo_basics_skill; // Default fallback
    }

    return {
      drillId: drill.id,
      sport: 'taekwondo',
      skill: drill.skill, // Use the skill name directly
      title: drill.name,
      description: drill.instructions,
      difficulty: drill.difficulty,
      ageRange: '6-10',
      duration: Math.floor(drill.timeTotal / 60), // Convert seconds to minutes
      points: computePointsFromSourceOfTruth(drill),
      exercises: [
        // Create a single exercise object from the drill data
        {
          id: drill.id,
          name: drill.name,
          title: drill.name,
          description: drill.instructions,
          instructions: drill.instructions,
          duration: drill.timeTotal,
          equipment: drill.equipment,
          timedInstructions: drill.timedInstructions,
        },
      ],
      intro: skill.intro || `Welcome to ${drill.name}! Let's get started!`,
      completion:
        skill.completion ||
        `Great job completing ${drill.name}! You're a taekwondo master!`,
      requiresPartner: false, // Taekwondo drills are individual
      minPlayers: 1,
    };
  });

// Add yoga drills to the sessions
const yogaDrills = allDrills
  .filter((drill) => drill.sports && drill.sports.includes('yoga'))
  .map((drill) => {
    // Map yoga drill skills to skill objects based on skill and difficulty
    let skill;
    if (drill.skill === 'Basics') {
      if (drill.difficulty === 'beginner') {
        skill = yoga_basics_beginner_skill;
      } else if (drill.difficulty === 'intermediate') {
        skill = yoga_basics_intermediate_skill;
      } else if (drill.difficulty === 'advanced') {
        skill = yoga_basics_advanced_skill;
      } else {
        skill = yoga_basics_beginner_skill; // Default fallback
      }
    } else if (drill.skill === 'Complete') {
      if (drill.difficulty === 'beginner') {
        skill = yoga_complete_beginner_skill;
      } else if (drill.difficulty === 'intermediate') {
        skill = yoga_complete_intermediate_skill;
      } else if (drill.difficulty === 'advanced') {
        skill = yoga_complete_advanced_skill;
      } else {
        skill = yoga_complete_beginner_skill; // Default fallback
      }
    } else {
      skill = yoga_basics_beginner_skill; // Default fallback
    }

    return {
      drillId: drill.id,
      sport: 'yoga',
      skill: drill.skill, // Use the skill name directly
      title: drill.name,
      description: drill.instructions,
      difficulty: drill.difficulty,
      ageRange: '6-10',
      duration: Math.floor(drill.timeTotal / 60), // Convert seconds to minutes
      points: computePointsFromSourceOfTruth(drill),
      exercises: [
        // Create a single exercise object from the drill data
        {
          id: drill.id,
          name: drill.name,
          title: drill.name,
          description: drill.instructions,
          instructions: drill.instructions,
          duration: drill.timeTotal,
          equipment: drill.equipment,
          timedInstructions: drill.timedInstructions,
        },
      ],
      intro: skill.intro || `Welcome to ${drill.name}! Let's get started!`,
      completion:
        skill.completion ||
        `Great job completing ${drill.name}! You're a yoga master!`,
      requiresPartner: false, // Yoga drills are individual
      minPlayers: 1,
    };
  });

// Add running drills to the sessions
const runningDrills = allDrills
  .filter((drill) => drill.sports && drill.sports.includes('running-technique'))
  .map((drill) => {
    // Map running technique drill skills to skill objects based on skill and difficulty
    let skill;
    if (drill.skill === 'Form') {
      skill = running_form_skill;
    } else if (drill.skill === 'Speed') {
      skill = running_speed_agility_skill;
    } else if (drill.skill === 'Endurance') {
      if (drill.difficulty === 'beginner') {
        skill = running_beginner_endurance_skill;
      } else if (drill.difficulty === 'intermediate') {
        skill = running_intermediate_endurance_skill;
      } else {
        skill = running_beginner_endurance_skill; // Default fallback
      }
    } else {
      skill = running_form_skill; // Default fallback
    }

    return {
      drillId: drill.id,
      sport: 'running-technique',
      skill: drill.skill, // Use the skill name directly
      title: drill.name,
      description: drill.instructions,
      difficulty: drill.difficulty,
      ageRange: '6-10',
      duration: Math.floor(drill.timeTotal / 60), // Convert seconds to minutes
      points: computePointsFromSourceOfTruth(drill),
      exercises: [
        // Create a single exercise object from the drill data
        {
          id: drill.id,
          name: drill.name,
          title: drill.name,
          description: drill.instructions,
          instructions: drill.instructions,
          duration: drill.timeTotal,
          equipment: drill.equipment,
          timedInstructions: drill.timedInstructions,
        },
      ],
      intro: skill.intro || `Welcome to ${drill.name}! Let's get started!`,
      completion:
        skill.completion ||
        `Great job completing ${drill.name}! You're a running master!`,
      requiresPartner: false, // Running technique drills are individual
      minPlayers: 1,
    };
  });

// Add soccer drills to the sessions
const soccerDrills = allDrills
  .filter(
    (drill) =>
      drill.sports &&
      drill.sports.includes('soccer') &&
      typeof drill.id === 'number' &&
      drill.id >= 2011 &&
      drill.id <= 2181
  )
  .map((drill) => {
    // Derive numeric skill ID from categories instead of free-text skill field
    const categories = Array.isArray(drill.categories) ? drill.categories : [];
    const cats = categories.map((c) => String(c).toLowerCase());
    const isPartner =
      cats.includes('partner') || cats.includes('partner drill');

    let skillId = 103; // default Technique
    if (isPartner) {
      if (cats.includes('passing') || cats.includes('wall kicking')) {
        skillId = 104; // Partner Passing
      } else if (cats.includes('dribbling')) {
        skillId = 106; // Partner Dribbling
      } else if (cats.includes('ball control')) {
        skillId = 105; // Partner Control
      } else {
        skillId = 107; // Partner Skills (general)
      }
    } else {
      if (cats.includes('dribbling')) {
        skillId = 101; // Dribbling
      } else if (cats.includes('wall kicking') || cats.includes('passing')) {
        skillId = 102; // Passing
      } else {
        skillId = 103; // Technique / Ball Control
      }
    }

    return {
      drillId: drill.id,
      sport: 'soccer',
      // Use numeric skill ID so the UI categories match (101-107)
      skill: skillId,
      title: drill.name,
      description: drill.instructions,
      difficulty: drill.difficulty,
      ageRange: '6-10',
      duration: Math.floor(drill.timeTotal / 60), // Convert seconds to minutes
      points: computePointsFromSourceOfTruth(drill),
      exercises: [
        // Create a single exercise object from the drill data
        {
          id: drill.id,
          name: drill.name,
          title: drill.name,
          description: drill.instructions,
          instructions: drill.instructions,
          duration: drill.timeTotal,
          equipment: drill.equipment,
          timedInstructions: drill.timedInstructions,
        },
      ],
      intro: `Welcome to ${drill.name}! Let's get started!`,
      completion: `Great job completing ${drill.name}! You're a soccer master!`,
      // Partner flag (derived from categories)
      requiresPartner: isPartner,
      minPlayers: isPartner ? 2 : 1,
    };
  });

// Add taekwondo skills from new-skills.js
const taekwondoSkills = [
  taekwondo_basics_skill,
  taekwondo_kicks_skill,
  taekwondo_techniques_skill,
  taekwondo_stances_skill,
  taekwondo_footwork_skill,
  taekwondo_combinations_skill,
  taekwondo_defense_skill,
  taekwondo_sparring_skill,
  taekwondo_forms_skill,
  taekwondo_complete_beginner_skill,
  taekwondo_complete_intermediate_skill,
  taekwondo_complete_advanced_skill,
  taekwondo_championship_skill,
].map((skill) => ({
  drillId: skill.skillId,
  sport: skill.sport,
  skill: skill.skill || skill.title, // Use title as fallback for skill
  title: skill.title,
  description: skill.description,
  difficulty: skill.difficulty,
  ageRange: '6-10',
  duration: skill.duration,
  points: skill.points,
  exercises: [], // These are complete workouts, not individual drills
  intro: `Welcome to ${skill.title}! Let's get started!`,
  completion: `Great job completing ${skill.title}! You're a taekwondo master!`,
  requiresPartner: false,
  minPlayers: 1,
}));

// Add yoga skills from new-skills.js
const yogaSkills = [
  yoga_basics_beginner_skill,
  yoga_basics_intermediate_skill,
  yoga_basics_advanced_skill,
  yoga_complete_beginner_skill,
  yoga_complete_intermediate_skill,
  yoga_complete_advanced_skill,
].map((skill) => ({
  drillId: skill.skillId,
  sport: skill.sport,
  skill: skill.skill || skill.title, // Use title as fallback for skill
  title: skill.title,
  description: skill.description,
  difficulty: skill.difficulty,
  ageRange: '6-10',
  duration: skill.duration,
  points: skill.points,
  exercises: [], // These are complete workouts, not individual drills
  intro: `Welcome to ${skill.title}! Let's get started!`,
  completion: `Great job completing ${skill.title}! You're a yoga master!`,
  requiresPartner: false,
  minPlayers: 1,
}));

// Add volleyball skills from new-skills.js
const volleyballSkills = [
  volleyball_beginner_passing_skill,
  volleyball_intermediate_passing_skill,
  volleyball_advanced_passing_skill,
  volleyball_beginner_setting_skill,
  volleyball_intermediate_setting_skill,
  volleyball_advanced_setting_skill,
  volleyball_beginner_serving_skill,
  volleyball_intermediate_serving_skill,
  volleyball_advanced_serving_skill,
  volleyball_complete_individual_skill,
].map((skill) => ({
  drillId: skill.skillId,
  sport: skill.sport,
  skill: skill.skill || skill.title, // Use title as fallback for skill
  title: skill.title,
  description: skill.description,
  difficulty: skill.difficulty,
  ageRange: '6-10',
  duration: skill.duration,
  points: skill.points,
  exercises: [], // These are complete workouts, not individual drills
  intro: `Welcome to ${skill.title}! Let's get started!`,
  completion: `Great job completing ${skill.title}! You're a volleyball master!`,
  requiresPartner: false,
  minPlayers: 1,
}));

// Add karate skills from new-skills.js
const karateSkills = [
  karate_beginner_stances_skill,
  karate_intermediate_stances_skill,
  karate_advanced_stances_skill,
  karate_beginner_strikes_skill,
  karate_intermediate_strikes_skill,
  karate_advanced_strikes_skill,
  karate_beginner_blocks_skill,
  karate_intermediate_blocks_skill,
  karate_advanced_blocks_skill,
  karate_complete_individual_skill,
  karate_beginner_combat_skill,
  karate_intermediate_combat_skill,
  karate_advanced_combat_skill,
].map((skill) => ({
  drillId: skill.skillId,
  sport: skill.sport,
  skill: skill.skill || skill.title, // Use title as fallback for skill
  title: skill.title,
  description: skill.description,
  difficulty: skill.difficulty,
  ageRange: '6-10',
  duration: skill.duration,
  points: skill.points,
  exercises: [], // These are complete workouts, not individual drills
  intro: `Welcome to ${skill.title}! Let's get started!`,
  completion: `Great job completing ${skill.title}! You're a karate master!`,
  requiresPartner: false,
  minPlayers: 1,
}));

// Add dance skills from new-skills.js
const danceSkills = [
  dance_beginner_movement_skill,
  dance_intermediate_movement_skill,
  dance_advanced_movement_skill,
  dance_beginner_rhythm_skill,
  dance_intermediate_rhythm_skill,
  dance_robot_rhythm_skill,
  dance_beginner_choreography_skill,
  dance_intermediate_choreography_skill,
  dance_advanced_choreography_skill,
  dance_complete_individual_skill,
  dance_beginner_combined_skill,
  dance_intermediate_combined_skill,
  dance_advanced_combined_skill,
].map((skill) => ({
  drillId: skill.skillId,
  sport: skill.sport,
  skill: skill.skill || skill.title, // Use title as fallback for skill
  title: skill.title,
  description: skill.description,
  difficulty: skill.difficulty,
  ageRange: '6-10',
  duration: skill.duration,
  points: skill.points,
  exercises: [], // These are complete workouts, not individual drills
  intro: `Welcome to ${skill.title}! Let's get started!`,
  completion: `Great job completing ${skill.title}! You're a dance master!`,
  requiresPartner: false,
  minPlayers: 1,
}));

// Add ballet skills from new-skills.js
const balletSkills = [
  ballet_beginner_basics_skill,
  ballet_intermediate_basics_skill,
  ballet_advanced_basics_skill,
  ballet_beginner_movement_skill,
  ballet_intermediate_movement_skill,
  ballet_advanced_movement_skill,
  ballet_beginner_grace_skill,
  ballet_intermediate_grace_skill,
  ballet_advanced_grace_skill,
  ballet_complete_individual_skill,
  ballet_beginner_combined_skill,
  ballet_intermediate_combined_skill,
  ballet_advanced_combined_skill,
].map((skill) => ({
  drillId: skill.skillId,
  sport: skill.sport,
  skill: skill.skill || skill.title, // Use title as fallback for skill
  title: skill.title,
  description: skill.description,
  difficulty: skill.difficulty,
  ageRange: '6-10',
  duration: skill.duration,
  points: skill.points,
  exercises: [], // These are complete workouts, not individual drills
  intro: `Welcome to ${skill.title}! Let's get started!`,
  completion: `Great job completing ${skill.title}! You're a ballet master!`,
  requiresPartner: false,
  minPlayers: 1,
}));

// Add running technique skills from new-skills.js
const runningTechniqueSkills = [
  running_form_skill,
  running_speed_agility_skill,
  running_beginner_endurance_skill,
  running_intermediate_endurance_skill,
  running_complete_beginner_skill,
  running_complete_intermediate_skill,
].map((skill) => ({
  drillId: skill.skillId,
  sport: skill.sport,
  skill: skill.skill || skill.title, // Use title as fallback for skill
  title: skill.title,
  description: skill.description,
  difficulty: skill.difficulty,
  ageRange: '6-10',
  duration: skill.duration,
  points: skill.points,
  exercises: [], // These are complete workouts, not individual drills
  intro: `Welcome to ${skill.title}! Let's get started!`,
  completion: `Great job completing ${skill.title}! You're a running master!`,
  requiresPartner: false,
  minPlayers: 1,
}));

// Combine all drills
const allSessionsDrills = [
  ...basketballDrills,
  ...basketballSkills,
  ...baseballDrills,
  ...baseballSkills,
  ...karateDrills,
  ...martialArtsDrills,
  ...soccerDrills,
  ...danceDrills,
  ...volleyballDrills,
  ...movementCoordinationDrills,
  ...boxingDrills,
  ...yogaDrills,
  ...yogaSkills,
  ...volleyballDrills,
  ...volleyballSkills,
  ...karateDrills,
  ...karateSkills,
  ...danceDrills,
  ...danceSkills,
  ...balletDrills,
  ...balletSkills,
  ...taekwondoDrills,
  ...runningDrills,
  ...runningTechniqueSkills,
];

// Helper function to sort drills based on player count
export const getSortedDrills = (sport, playerCount = 1) => {
  const sportDrills = allSessionsDrills.filter(
    (drill) => drill.sport === sport
  );

  if (playerCount > 1) {
    // Split, sort by id within each, then merge partner first
    const partners = sportDrills
      .filter((d) => d.requiresPartner)
      .sort((a, b) => a.drillId - b.drillId);
    const individuals = sportDrills
      .filter((d) => !d.requiresPartner)
      .sort((a, b) => a.drillId - b.drillId);
    return [...partners, ...individuals];
  }
  // Single player: sort all by id ascending
  return sportDrills.sort((a, b) => a.drillId - b.drillId);
};

export default allSessionsDrills;
